import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SearchWidgetComponent } from './search-widget.component';
import { FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

@NgModule({
    declarations: [
        SearchWidgetComponent,
    ],
    imports: [
        FuseWidgetModule,
        FuseSharedModule,
        CommonModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        FormsModule,
        MatIconModule,
        MatToolbarModule,
     ],
    exports: [
        SearchWidgetComponent,

    ],
    providers: [],
})
export class SearchWidgetModule {}
